<template>
  <v-row
    justify="center"
    align="center"
    class="login-background"
  >
    <v-col
      cols="10"
      sm="6"
      md="4"
    >
      <v-card>
        <v-card-title>
          Relief Spa&massage
          <v-icon
            right
            left
          >
            fas fa-user-cog
          </v-icon>
          ADMIN
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="email"
            label="อีเมล"
            filled
            color="orange"
          />
          <v-text-field
            v-model="password"
            label="รหัสผ่าน"
            type="password"
            filled
            color="orange"
            @keydown.enter="login"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="orange"
            @click="login"
          >
            เข้าสู่ระบบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import http from '@/http';
import { SET_USER } from '@/store/mutation_types';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    ...mapActions([SET_USER]),
    async login() {
      const user = await http.post('/auth/user', {
        email: this.email,
        password: this.password,
      });
      this.SET_USER(user.data);
      this.$router.push('/admin');
    },
  },
};
</script>

<style scoped>
.login-background {
  background-image: url('~@/assets/admin_login.jpg');
  background-size: cover;
}
</style>
